import React from "react";
import Marquee from "react-fast-marquee";
import "./ticker.css";
import { RTL } from "../../global";

const Ticker = (props) => {


  return (
    <div className={RTL?"pos-fixed":"pos_zind"}>
      {props.tickData !== undefined && props.tickData !== null ? (
        <div id="newsTicker1" className="ent_wrapper scroll-effect">
          <div className="ent_label">
            <h2>{props.tickData.ticker.referenceName}</h2>
            <span></span>
          </div>
          <div className="ent_news_wrapper">
            <Marquee className='broken_tick' gradient={false} speed={50} loop={0} delay={0} direction={RTL?"right":"left"} >
              {props.tickData.ticker.items.map((elem, index) => (
                <div key={index} className="ticker-slide">
                  <div className="inner">
                    <div className="ent_news swiper-slide">
                      <a
                        href="#!"
                        className="ent_news_url"
                        onClick={(event) => {
                          event.preventDefault();
                        }}
                      >
                        <div className="ent_prefix">{elem.itemRef}</div>
                        <div className="ent_date"></div>
                        <div className="ent_heading">{elem.itemid}</div>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </Marquee>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Ticker;
